export const RFI_REQUESTS_DOMAIN = 'rfi-requests';
export const RFI_REQUESTS_DOMAIN_URL = '/rfi-requests/*';

export const RFI_REQUESTS_PATHS = {
  list: '/list',
  detail: '/detail/:id',
  /** Match Files: place the files a request received on its file lines */
  matchFiles: '/:uuid/match',
};

export const RFI_REQUESTS_PAGE_TITLES = {
  list: 'RFI Requests',
  detail: 'RFI Request Detail',
  matchFiles: 'Match Files',
};
